import React from "react";
import "./App.css";

import HomeGroup from "./Components/Groups/HomeGroup";
import WorkGroupGreenhub from "./Components/Groups/WorkGroup-Greenhub";
import WorkGroupTsundoku from "./Components/Groups/WorkGroup-Tsundoku";
import WorkGroupPortfolio from "./Components/Groups/WorkGroup-Portfolio";
import ContactGroup from "./Components/Groups/ContactGroup";
import WorkGroupTsundokuAdminStudio from "./Components/Groups/WorkGroup-TsundokuAdminStudio";
import ErrorPageGroup from "./Components/Groups/ErrorPageGroup";

import { Route, Routes } from "react-router-dom";

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomeGroup />} />
        <Route
          path="/Work-TsundokuAdminStudio"
          element={<WorkGroupTsundokuAdminStudio />}
        />
        <Route path="/Work-Greenhub" element={<WorkGroupGreenhub />} />
        <Route path="/Work-Tsundoku" element={<WorkGroupTsundoku />} />
        <Route path="/Work-Portfolio" element={<WorkGroupPortfolio />} />
        <Route path="/Contact" element={<ContactGroup />} />
        <Route path="/*" element={<ErrorPageGroup />} />
      </Routes>
    </>
  );
};
export default App;
